import { useCallback, useState } from 'react';

interface UseProductFamilyLogicProps {
	initialFamilyId?: number;
	initialProduct?: any;
	onFamilyAutoFill?: (familyId: number, familyName: string) => void;
}

interface UseProductFamilyLogicReturn {
	familyId: number | undefined;
	selectedProduct: any;
	handleOnChangeFamily: (value: any) => void;
	handleOnChangeProduct: (value: any) => void;
	isDisabledProductAutocomplete: () => boolean;
	shouldClearAutocompleteProduct: () => boolean;
}

export const useProductFamilyLogic = ({
	initialFamilyId,
	initialProduct,
	onFamilyAutoFill,
}: UseProductFamilyLogicProps = {}): UseProductFamilyLogicReturn => {
	const [familyId, setFamilyId] = useState<number | undefined>(
		initialFamilyId
	);
	const [selectedProduct, setSelectedProduct] = useState<any>(initialProduct);

	const handleOnChangeFamily = useCallback(
		(value: any) => {
			const newFamilyId = value?.id;

			if (selectedProduct && newFamilyId !== familyId) {
				setSelectedProduct(null);
			}

			setFamilyId(newFamilyId);
		},
		[selectedProduct, familyId]
	);

	const handleOnChangeProduct = useCallback(
		(value: any) => {
			setSelectedProduct(value);

			if (value?.familia_id && !familyId) {
				setFamilyId(value.familia_id);

				if (onFamilyAutoFill && value.nome_familia) {
					onFamilyAutoFill(value.familia_id, value.nome_familia);
				}
			}
		},
		[familyId, onFamilyAutoFill]
	);

	const isDisabledProductAutocomplete = useCallback(() => {
		return false;
	}, []);

	const shouldClearAutocompleteProduct = useCallback(() => {
		if (!selectedProduct && familyId) {
			return true;
		}

		return false;
	}, [familyId, selectedProduct]);

	return {
		familyId,
		selectedProduct,
		handleOnChangeFamily,
		handleOnChangeProduct,
		isDisabledProductAutocomplete,
		shouldClearAutocompleteProduct,
	};
};
